export class AddressPicker
{
    constructor({ rootNode, locationNode })
    {
        this.rootNode = rootNode;
        this.locationNode = locationNode;
        
        this.eventEmitter = new BX.Event.EventEmitter(this);
        this.eventEmitter.setEventNamespace('Mario.AdressPicker.');
        
        this.init();
        this.bindEvents();
    }

    bindEvents()
    {
        if (this.getEntity('add-address')) {
            this.getEntity('add-address')
                .addEventListener('click', () => this.enableAddressForm());
        }

        this.getAllEntities('address-item').forEach(item => {
            item.addEventListener('change', () => {
                this.disabledAddressForm();
            })
        });
    }

    init()
    {
        this.initStreetInput();
    }

    initStreetInput()
    {
        const input = this.getEntity('street-input');
        if (!input) {
            return;
        }

        $(input).autocomplete({
            source: (request, response) => {
                const location = this.locationNode.value;
                const query = input.value;

                $.ajax({
                    url: '/ajax/location/search_street/',
                    data: { location, query },
                    dataType: "json",
                    success: (data) => response(data),
                    error: () => response([]),
                });
            },
            minLength: 2,
        });
    }

    enableAddressForm()
    {
        BX.Dom.style(this.getEntity('address-form'), 'display', 'block');
        BX.Dom.style(this.getEntity('add-address'), 'display', 'none');

        this.getEntity('address-type').value = 'separate';

        this.getAllEntities('address-item').forEach(item => item.checked = false);

        this.eventEmitter.emit('toggleForm');
    }

    disabledAddressForm()
    {
        BX.Dom.style(this.getEntity('address-form'), 'display', 'none');
        BX.Dom.style(this.getEntity('add-address'), 'display', 'block');

        this.getEntity('address-type').value = 'select';

        this.eventEmitter.emit('toggleForm');
    }

    getEntity(entityName, rootNode = null)
    {
        return (rootNode || this.rootNode).querySelector(`[data-entity="${entityName}"]`);
    }

    getAllEntities(entityName, rootNode = null)
    {
        return (rootNode || this.rootNode).querySelectorAll(`[data-entity="${entityName}"]`);
    }

    subscribe(eventName, cb = () => {}) 
    {
        this.eventEmitter.subscribe(eventName, cb);
    }
}